// extracted by mini-css-extract-plugin
export default {"list":"EventListPage_list__-hppL"};